module.exports = __webpack_public_path__ + "img/1ExghtrsxxftNMncNGTuh6PAEPGO-4o1R.4dd2b748.png";